import * as React from "react"

export interface TitleHeaderProps {
  title: string
}

export class TitleHeader extends React.Component<TitleHeaderProps> {
  render(): React.ReactNode {
    return (
      <div className="relative z-100 overflow-visible max-w-2xl md:text-7xl sm:text-5xl text-4xl">
        <h1 className="absolute -z-10 top-1/2 -translate-y-1/2 left-2 font-bold max-w-2xl text-pink-400 opacity-10 leading-snug">
          {this.props.title}
        </h1>
        <h1 className="absolute -z-10 top-1/2 -translate-y-1/2 -left-2 font-bold max-w-2xl text-blue-400 opacity-10 leading-snug">
          {this.props.title}
        </h1>
        <h1 className="relative font-bold max-w-2xl text-primary">
          {this.props.title}
        </h1>
      </div>
    )
  }
}
